import React from 'react'
import { Row, Col, Table } from "react-bootstrap";
import { checkArray, personToString } from '../helpers/util';
import { ensureInschriften, sortInschriften, inscriptionHeading, ANORDNUNG_ORDER } from '../helpers/inscriptionUtils';


const InscriptionRow = ({linenumber, text, u1, u0}) => (
    <tr>
        <td  style={{width: "50%"}}>
            <div dir='auto' align='right'>{text[linenumber]}</div>
            
        </td>
        <td style={{backgroundColor: '#ffffff'}}>{(linenumber + 1) % 5 === 0 ? linenumber + 1 : ""}</td>
        <td style={{width: "50%"}}>
			{checkArray(u1)? <div>{u1[linenumber]}</div> : <div>{u0[linenumber]}</div>}
        </td>
    </tr>
)

const hasText = (block) => checkArray(block && block.text);

const personLabel = (block, persons) => {
	if (!block.personId || !Array.isArray(persons)) {
		return "";
	}
	const person = persons.find(entry => entry && entry.id === block.personId);
	return person ? personToString(person) : "";
};

export default class DetailElementInscription extends React.Component {

  	render() {
		const tombstone = this.props.tombstone || { inschrift_hebraeisch: this.props.value, inschriften: this.props.inschriften, persons: this.props.persons };
		ensureInschriften(tombstone);
		const blocks = sortInschriften(tombstone.inschriften || []).filter(hasText);
		if (blocks.length === 0) {
			return (<div></div>);
		}
    	return (<div>
      			<Row >
					<Col style={{backgroundColor: '#ffffff'}}>
						<strong>{this.props.name}</strong>
						{this.props.rights? this.props.rights.map((entry, id)=>( entry.reference === "inscription"?<div key={id}>{entry.rightChoices.map((right)=>(<div key={entry.id}>{right.value}{right.comment?" | "+right.comment:""}</div>))}</div>:"" )):""}
					</Col>
      			</Row>
				{ANORDNUNG_ORDER.map(anordnung => {
					const grouped = blocks.filter(block => block.anordnung === anordnung);
					return grouped.map((block, index) => {
						let linenumber = 0;
						const heading = inscriptionHeading(block);
						const assignedPerson = personLabel(block, tombstone.persons);
						return (
							<div key={block.id || anordnung + "-" + index} id={block.id ? "inschrift-" + block.id : undefined}>
								<Row >
									<Col md={{ span: 11, offset: 1 }} style={{backgroundColor: '#ffffff'}}>
										<strong>{heading}</strong>
										{assignedPerson ? <span> — {assignedPerson}</span> : ""}
									</Col>
								</Row>
								<Row >
									<Col md={{ span: 11, offset: 1 }} style={{backgroundColor: '#fbfbfb'}}>	
									 <Table>
										{index === 0 ? (
				                        <thead>
				                            <tr>
				                                <th>Inschrift</th>
				                                <th></th>
				                                <th>Übersetzung</th>
				                            </tr>
				                        </thead>
										) : null}
				                        <tbody>
				                            {block.text.map((line, i) => <InscriptionRow 
																					linenumber={linenumber++} 
																					text={block.text} 
																					u1={block.uebersetzung_1}
																					u0={block.uebersetzung_0}  
																					key={i}/>)}
				                        </tbody>
				                    </Table>
				       				</Col>
				      			</Row> 
							</div>
						);
					});
				})}
			</div>
			
    )
  }
}
